import '../app-common/main';
import '../app-data/main';

import './app';

import './app-init';

import './components/project-item/project-item';
import './directives/plan-thumbnail';
import './components/project-list/project-list';
import './components/gp-buy-credits-dialog/gp-buy-credits-dialog';
import './components/gp-cancel-subscription-dialog/gp-cancel-subscription-dialog';
import './components/gp-check-to-reenable-billing-dialog/gp-check-to-reenable-billing-dialog';
import './components/gp-licence-options-dialog/gp-licence-options-dialog';
import './components/login/login';
import './components/subscription-management/subscription-management';
import './components/subscription-management/personal-subscriptions/personal-subscriptions';
import './components/subscription-management/team-subscriptions/team-subscriptions';
import './components/subscription-control/subscription-control';
import './components/ai-credits/ai-credits';
import './components/ai-credits-purchase/ai-credits-purchase';
import './components/signup/signup';

import './controllers/account-controller';
import './controllers/boards-controller';
import './controllers/confirmemail-controller';
import './controllers/confirmemailchange-controller';
import './controllers/create-password-controller';
import './controllers/index-controller';
import './controllers/index-toolbar-controller';

import './controllers/newboard-controller';

import './controllers/templates-controller';
import './controllers/welcome-controller';

import './services/account-prefetch-service';
import './services/accounts-service';
import './services/auth-service';
import '../app-common/services/projects-service';
import './services/route-auth-service';
import './services/subscription-management-mock-service';
import './services/ai-credits-service';
import './services/ai-credits-purchase-service';
import './services/analysis-contract';
import './services/analysis-project-processing-service';
import './services/analysis-project-service';

// Register the CPM intelligence service on the app-home module
import { gpHome } from './app';
import { CpmIntelligenceService, CpmIntelligenceServiceName } from '../app-plan/scheduling/cpm-intelligence-service';
gpHome.service(CpmIntelligenceServiceName, CpmIntelligenceService);

import './components/analyze-list/analyze-list';
import './components/analysis-list-item/analysis-list-item';
import './components/analyze-detail/analyze-detail';
import './components/analysis-task-list/analysis-task-list';
import './components/analysis-report/analysis-report';
